import Form from './Form'

interface TuneOption {
  id: number
  name: string
}

interface Props {
  tunes: TuneOption[]
  errors?: Record<string, string | string[]>
}

export default function New({ tunes, errors }: Props) {
  return (
    <Form
      heading="New set"
      title="New set"
      submitLabel="Create set"
      action="/sets"
      method="post"
      tunes={tunes}
      errors={errors}
    />
  )
}
